function ShowErrorAlert(msg) {
    //if (msg !== null && msg !== '') {
    //    $(".alert-danger-message").html(msg);
    //}
    //$(".alert-danger.alert-popup-message").slideToggle(200);
    //setTimeout(function () { $(".global-alert.alert-danger.alert-popup-message").slideToggle(200); }, 2500);
    iziToast.error({
        title: 'Error',
        message: msg,
        position: 'topCenter',
        timeout: 2500
    });
};
function ShowInfoAlert(msg) {
    //if (msg !== null && msg !== '') {
    //    $(".alert-info-message").html(msg);
    //}
    //$(".alert-info.alert-info-popup-message").slideToggle(200);
    //setTimeout(function () { $(".global-alert.alert-info.alert-info-popup-message").slideToggle(200); }, 2500);
    iziToast.info({
        title: '',
        message: msg,
        position: 'topCenter',
        timeout: 2500
    });
};
function ConfirmMembershipRemoval(membershipProgramId) {
    $("#membership-removal-modal-" + membershipProgramId).modal();
}
function ShowMultiEventWarning() {
    $("#multi-client-cart-modal").modal({ backdrop: 'static', keyboard: false });
}
window.mobileCheck = function () {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};
function createEWalletTickets(o, token) {
    //var phoneNumber = $("#text-ewallet").val();
    //if (phoneNumber == null || phoneNumber.length < 7)
    //    return;
    //TODO uncomment when SMS delivery is allowed in wrstbnd
    var phoneNumber = '';
    ShowLoadingOverlay();
    $("#submit-ewallet").attr('disabled', 'disabled');
    $("#text-ewallet").attr('disabled', 'disabled');
    axios({
        method: 'post',
        url: baseUrl + 't/EWallet',
        data: {
            p: phoneNumber,
            o: o
        },
        headers: {
            'RequestVerificationToken': token
        }
    }).then(function (response) {
        HideLoadingOverlay();
        
        if (response.status == 200) {
            //ShowInfoAlert("Success! You should receive a text message shortly with instructions on how add your tickets to your phone's wallet.");
            ShowInfoAlert("Success! You should receive an e-mail shortly with a link to install the tickets to your phone's wallet.");
        } else {
            //ShowErrorAlert("There was an error please review your phone number and try again");
            ShowErrorAlert("There was an error please try again");
            $("#submit-ewallet").removeAttr('disabled');
            $("#text-ewallet").removeAttr('disabled');
        }
    }).catch(function (err) {
        HideLoadingOverlay();
        if (err.response.status == 409) {
            ShowErrorAlert("There was an error retrieving your mobile wallet tickets. Please contact our support team.");
            return;
        }
        console.error(err);
        //ShowErrorAlert("There was an error please review your phone number and try again");
        ShowErrorAlert("There was an error please try again");
        $("#submit-ewallet").removeAttr('disabled');
        $("#text-ewallet").removeAttr('disabled');
    });
}

var interval = [];
function expirationTimer(itemDetail, expirationTime) {
    interval[itemDetail.LockId] = setInterval(function () {
        expirationTime--;
        if (expirationTime <= 0) {
            $("#expire-item-name").html(itemDetail.ItemName);
            if (itemDetail.ItemType === 'ticket') {
                $("#expire-header-" + itemDetail.LockId).html("Tickets for " + itemDetail.ItemName);
                $("#expire-msg-" + itemDetail.LockId).html("your tickets to <strong>" + itemDetail.ItemName + "</strong>");
            }
            if (itemDetail.ItemType === 'package') {
                $("#expire-header-" + itemDetail.LockId).html("Package " + itemDetail.ItemName);
                $("#expire-msg-" + itemDetail.LockId).html("your package <strong>" + itemDetail.ItemName + "</strong>");
            }
            if (itemDetail.ItemType === 'pass') {
                $("#expire-header-" + itemDetail.LockId).html("Pass " + itemDetail.ItemName);
                $("#expire-msg-" + itemDetail.LockId).html("your pass <strong>" + itemDetail.ItemName + "</strong>");
            }
            if (itemDetail.ItemType === 'extra') {
                $("#expire-header-" + itemDetail.LockId).html("Extra " + itemDetail.ItemName);
                $("#expire-msg-" + itemDetail.LockId).html("your extra <strong>" + itemDetail.ItemName + "</strong>");
            }
            $("#expire-modal-" + itemDetail.LockId).modal();
            clearInterval(interval[itemDetail.LockId]);
        }
    },
        1000);
}

function ShowWidgetMsg(msg) {
    //window.parent.postMessage(JSON.stringify({ isMsg: 'true', msg: msg }), "*");
    iziToast.info({
        title: '',
        message: msg,
        position: 'topCenter',
        timeout: 2500
    });
}

function ShowWidgetError(msg) {
    //window.parent.postMessage(JSON.stringify({ isError: 'true', msg: msg }), "*");
    iziToast.error({
        title: 'Error',
        message: msg,
        position: 'topCenter',
        timeout: 2500
    });
}

function CloseWidget() {
    window.parent.postMessage('close', "*");
}

function SendWidgetData(modalData) {
    var data = JSON.parse(modalData);
    var body = document.body,
        html = document.documentElement;

    var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0
        || !(!!window.chrome && !!window.chrome.webstore) && !((!!window.opr && !!opr.addons)
            || !!window.opera
            || navigator.userAgent.indexOf(' OPR/') >= 0)
        && window.webkitAudioContext !== undefined;

    if (isSafari && Math.max(document.documentElement.clientWidth, window.innerWidth || 0) <= 768) {
        data.ContentHeight = data.SafariHeight;
    } else {
        var height = Math.max(body.scrollHeight,
            body.offsetHeight,
            body.clientHeight,
            html.offsetHeight);
        data.ContentHeight = height;
    }
    
    if (data.ContentHeight > data.SafariHeight)
        data.ContentHeight = data.SafariHeight;

    window.parent.postMessage(JSON.stringify(data), "*");
}
/**
 * Emulate FormData for some browsers
 * MIT License
 * (c) 2010 François de Metz
 */
(function (w) {
    if (w.FormData)
        return;
    function FormData() {
        this.fake = true;
        this.boundary = "--------FormData" + Math.random();
        this._fields = [];
    }
    FormData.prototype.append = function (key, value) {
        this._fields.push([key, value]);
    }
    FormData.prototype.toString = function () {
        var boundary = this.boundary;
        var body = "";
        this._fields.forEach(function (field) {
            body += "--" + boundary + "\r\n";
            // file upload
            if (field[1].name) {
                var file = field[1];
                body += "Content-Disposition: form-data; name=\"" + field[0] + "\"; filename=\"" + file.name + "\"\r\n";
                body += "Content-Type: " + file.type + "\r\n\r\n";
                body += file.getAsBinary() + "\r\n";
            } else {
                body += "Content-Disposition: form-data; name=\"" + field[0] + "\";\r\n\r\n";
                body += field[1] + "\r\n";
            }
        });
        body += "--" + boundary + "--";
        return body;
    }
    w.FormData = FormData;
})(window);

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
                                   || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function (callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function () { callback(currTime + timeToCall); },
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
}());

_browser = {};

function detectBrowser() {
    var uagent = navigator.userAgent.toLowerCase(),
        match = '';

    _browser.chrome = /webkit/.test(uagent) &&
        /chrome/.test(uagent) &&
        !/edge/.test(uagent);

    _browser.firefox = /mozilla/.test(uagent) && /firefox/.test(uagent);

    _browser.msie = /msie/.test(uagent) ||
        /trident/.test(uagent) ||
        /edge/.test(uagent);

    _browser.safari = /safari/.test(uagent) &&
        /applewebkit/.test(uagent) &&        
        !/chrome/.test(uagent);

    _browser.opr = /mozilla/.test(uagent) &&
        /applewebkit/.test(uagent) &&
        /chrome/.test(uagent) &&
        /safari/.test(uagent) &&
        /opr/.test(uagent);

    _browser.version = '';

    _browser.ipad = /ipad/.test(uagent);

    _browser.android = /android/.test(uagent);

    _browser.is_safari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0
		|| !(!!window.chrome && !!window.chrome.webstore)
		&& !((!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0)
		&& window.webkitAudioContext !== undefined;
    
    for (x in _browser) {
        if (_browser[x]) {

            match = uagent.match(
                new RegExp("(" + (x === "msie" ? "msie|edge" : x) + ")( |\/)([0-9]+)")
            );

            if (match) {
                _browser.version = match[3];
            } else {
                match = uagent.match(new RegExp("rv:([0-9]+)"));
                _browser.version = match ? match[1] : "599";
            }
            $("#browserResult")
                .append("<br/>The browser is <b>" +
                    (x === "opr" ? "Opera" : x) +
                    "</b> v. <b>" +
                    (_browser.version ? _browser.version : "N/A") +
                    "</b>");
            break;
        }
    }
    _browser.opera = _browser.opr;
    delete _browser.opr;
}

$(function () {
    detectBrowser();
    $('li.dropdown').hover(function () {
        $(this).find('.dropdown-menu').addClass('show');
    }, function () {
        var that = this;
        setTimeout(function () {
            $(that).find('.dropdown-menu').removeClass('show');
        }, 250);
    });
    setTimeout(function () { $("#session-expire-modal").modal({ backdrop: 'static', keyboard: false }); },
        30 * 60 * 1000);
    if (window.self !== window.top) {
        $("#footer").hide();
    }
});

/* sortArray Function */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.sortArray = factory());
}(this, (function () {
    'use strict';

    /**
     * Takes any input and guarantees an array back.
     *
     * - Converts array-like objects (e.g. `arguments`, `Set`) to a real array.
     * - Converts `undefined` to an empty array.
     * - Converts any another other, singular value (including `null`, objects and iterables other than `Set`) into an array containing that value.
     * - Ignores input which is already an array.
     *
     * @module array-back
     * @example
     * > const arrayify = require('array-back')
     *
     * > arrayify(undefined)
     * []
     *
     * > arrayify(null)
     * [ null ]
     *
     * > arrayify(0)
     * [ 0 ]
     *
     * > arrayify([ 1, 2 ])
     * [ 1, 2 ]
     *
     * > arrayify(new Set([ 1, 2 ]))
     * [ 1, 2 ]
     *
     * > function f(){ return arrayify(arguments); }
     * > f(1,2,3)
     * [ 1, 2, 3 ]
     */

    function isObject$1(input) {
        return typeof input === 'object' && input !== null
    }

    function isArrayLike$1(input) {
        return isObject$1(input) && typeof input.length === 'number'
    }

    /**
     * @param {*} - The input value to convert to an array
     * @returns {Array}
     * @alias module:array-back
     */
    function arrayify(input) {
        if (Array.isArray(input)) {
            return input
        } else if (input === undefined) {
            return []
        } else if (isArrayLike$1(input) || input instanceof Set) {
            return Array.from(input)
        } else {
            return [input]
        }
    }

    /**
     * Isomorphic, functional type-checking for Javascript.
     * @module typical
     * @typicalname t
     * @example
     * const t = require('typical')
     * const allDefined = array.every(t.isDefined)
     */

    /**
     * Returns true if input is a number. It is a more reasonable alternative to `typeof n` which returns `number` for `NaN` and `Infinity`.
     *
     * @param {*} - the input to test
     * @returns {boolean}
     * @static
     * @example
     * > t.isNumber(0)
     * true
     * > t.isNumber(1)
     * true
     * > t.isNumber(1.1)
     * true
     * > t.isNumber(0xff)
     * true
     * > t.isNumber(0644)
     * true
     * > t.isNumber(6.2e5)
     * true
     * > t.isNumber(NaN)
     * false
     * > t.isNumber(Infinity)
     * false
     */
    function isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n)
    }

    /**
     * A plain object is a simple object literal, it is not an instance of a class. Returns true if the input `typeof` is `object` and directly decends from `Object`.
     *
     * @param {*} - the input to test
     * @returns {boolean}
     * @static
     * @example
     * > t.isPlainObject({ something: 'one' })
     * true
     * > t.isPlainObject(new Date())
     * false
     * > t.isPlainObject([ 0, 1 ])
     * false
     * > t.isPlainObject(/test/)
     * false
     * > t.isPlainObject(1)
     * false
     * > t.isPlainObject('one')
     * false
     * > t.isPlainObject(null)
     * false
     * > t.isPlainObject((function * () {})())
     * false
     * > t.isPlainObject(function * () {})
     * false
     */
    function isPlainObject(input) {
        return input !== null && typeof input === 'object' && input.constructor === Object
    }

    /**
     * An array-like value has all the properties of an array yet is not an array instance. An example is the `arguments` object. Returns `true`` if the input value is an object, not `null`` and has a `length` property set with a numeric value.
     *
     * @param {*} - the input to test
     * @returns {boolean}
     * @static
     * @example
     * function sum(x, y){
     *   console.log(t.isArrayLike(arguments))
     *   // prints `true`
     * }
     */
    function isArrayLike(input) {
        return isObject(input) && typeof input.length === 'number'
    }

    /**
     * Returns true if the typeof input is `'object'` but not null.
     * @param {*} - the input to test
     * @returns {boolean}
     * @static
     */
    function isObject(input) {
        return typeof input === 'object' && input !== null
    }

    /**
     * Returns true if the input value is defined.
     * @param {*} - the input to test
     * @returns {boolean}
     * @static
     */
    function isDefined(input) {
        return typeof input !== 'undefined'
    }

    /**
     * Returns true if the input value is undefined.
     * @param {*} - the input to test
     * @returns {boolean}
     * @static
     */
    function isUndefined(input) {
        return !isDefined(input)
    }

    /**
     * Returns true if the input value is null.
     * @param {*} - the input to test
     * @returns {boolean}
     * @static
     */
    function isNull(input) {
        return input === null
    }

    /**
     * Returns true if the input value is not one of `undefined`, `null`, or `NaN`.
     * @param {*} - the input to test
     * @returns {boolean}
     * @static
     */
    function isDefinedValue(input) {
        return isDefined(input) && !isNull(input) && !Number.isNaN(input)
    }

    /**
     * Returns true if the input value is an ES2015 `class`.
     * @param {*} - the input to test
     * @returns {boolean}
     * @static
     */
    function isClass(input) {
        if (typeof input === 'function') {
            return /^class /.test(Function.prototype.toString.call(input))
        } else {
            return false
        }
    }

    /**
     * Returns true if the input is a string, number, symbol, boolean, null or undefined value.
     * @param {*} - the input to test
     * @returns {boolean}
     * @static
     */
    function isPrimitive(input) {
        if (input === null) return true
        switch (typeof input) {
            case 'string':
            case 'number':
            case 'symbol':
            case 'undefined':
            case 'boolean':
                return true
            default:
                return false
        }
    }

    /**
     * Returns true if the input is a Promise.
     * @param {*} - the input to test
     * @returns {boolean}
     * @static
     */
    function isPromise(input) {
        if (input) {
            const isPromise = isDefined(Promise) && input instanceof Promise;
            const isThenable = input.then && typeof input.then === 'function';
            return !!(isPromise || isThenable)
        } else {
            return false
        }
    }

    /**
     * Returns true if the input is an iterable (`Map`, `Set`, `Array`, Generator etc.).
     * @param {*} - the input to test
     * @returns {boolean}
     * @static
     * @example
     * > t.isIterable('string')
     * true
     * > t.isIterable(new Map())
     * true
     * > t.isIterable([])
     * true
     * > t.isIterable((function * () {})())
     * true
     * > t.isIterable(Promise.resolve())
     * false
     * > t.isIterable(Promise)
     * false
     * > t.isIterable(true)
     * false
     * > t.isIterable({})
     * false
     * > t.isIterable(0)
     * false
     * > t.isIterable(1.1)
     * false
     * > t.isIterable(NaN)
     * false
     * > t.isIterable(Infinity)
     * false
     * > t.isIterable(function () {})
     * false
     * > t.isIterable(Date)
     * false
     * > t.isIterable()
     * false
     * > t.isIterable({ then: function () {} })
     * false
     */
    function isIterable(input) {
        if (input === null || !isDefined(input)) {
            return false
        } else {
            return (
                typeof input[Symbol.iterator] === 'function' ||
                typeof input[Symbol.asyncIterator] === 'function'
            )
        }
    }

    /**
     * Returns true if the input value is a string. The equivalent of `typeof input === 'string'` for use in funcitonal contexts.
     * @param {*} - the input to test
     * @returns {boolean}
     * @static
     */
    function isString(input) {
        return typeof input === 'string'
    }

    /**
     * Returns true if the input value is a function. The equivalent of `typeof input === 'function'` for use in funcitonal contexts.
     * @param {*} - the input to test
     * @returns {boolean}
     * @static
     */
    function isFunction(input) {
        return typeof input === 'function'
    }

    var t = {
        isNumber,
        isPlainObject,
        isArrayLike,
        isObject,
        isDefined,
        isUndefined,
        isNull,
        isDefinedValue,
        isClass,
        isPrimitive,
        isPromise,
        isIterable,
        isString,
        isFunction
    };

    /**
     * Isomorphic, load-anywhere function to sort an array by scalar, deep or computed values in any standard or custom order.
     *
     * @module sort-array
     * @typicalname sortArray
     * @example
     * const sortArray = require('sort-array')
     */

    /**
     * @param {Array} array - The input array to sort. It is sorted in place.
     * @param {object} [options] - Sort options.
     * @param {string[]} [options.by] - One or more property names or computed fields to sort by. Specifying property names is only relevant when sorting an array of objects.
     * @param {string[]} [options.order] - One or more sort orders. Specify `'asc'`, `'desc'` or a property name from the `options.customOrders` object.
     * @param {object} [options.customOrders] - A dictionary object containing one or more custom orders. Each custom order value must be an array defining the order expected values must be sorted in.
     * @param {object} [options.computed] - A dictionary object containing one or more computed field functions. The function will be invoked once per item in the array. Each invocation will receive the array item as input and must return a primitive value by which the array can be sorted.
     * @param {number} [options.nullRank] - Configures whether `null` values will be sorted before or after defined values. Set to `-1` for before, `1` for after. Defaults to `1`.
     * @param {number} [options.undefinedRank] - Configures whether `undefined` values will be sorted before or after defined values. Set to `-1` for before, `1` for after. Defaults to `1`.
     * @returns {Array} Returns the array that was passed in.
     * @alias module:sort-array
     */
    function sortArray(arr, options = {}) {
        options = Object.assign(
            {
                computed: {},
                customOrders: {},
                nullRank: 1,
                undefinedRank: 1
            },
            options
        );
        arr.sort(getCompareFunc(options));
        return arr
    }

    function getCompareFunc(options = {}) {
        const by = arrayify(options.by);
        const order = arrayify(options.order);
        const { customOrders, computed } = options;
        return function compareFunc(xIn, yIn, byIndex = 0) {
            const currOrder = order[byIndex] || 'asc';
            if (!(currOrder === 'asc' || currOrder === 'desc' || customOrders[currOrder])) {
                return 0
            }

            let result, x, y;
            if (by.length) {
                x = t.isDefined(xIn[by[byIndex]])
                    ? xIn[by[byIndex]]
                    : computed[by[byIndex]] && computed[by[byIndex]](xIn);
                y = t.isDefined(yIn[by[byIndex]])
                    ? yIn[by[byIndex]]
                    : computed[by[byIndex]] && computed[by[byIndex]](yIn);
            } else {
                x = xIn;
                y = yIn;
            }

            if (customOrders && customOrders[currOrder]) {
                result = customOrders[currOrder].indexOf(x) - customOrders[currOrder].indexOf(y);
            } else if (x === y) {
                result = 0;
            } else if (t.isNull(x) && t.isUndefined(y)) {
                result = currOrder === 'asc'
                    ? 1
                    : currOrder === 'desc'
                        ? -1
                        : 0;
            } else if (t.isUndefined(x) && t.isNull(y)) {
                result = currOrder === 'asc'
                    ? -1
                    : currOrder === 'desc'
                        ? 1
                        : 0;
            } else if (t.isNull(x) && t.isDefinedValue(y)) {
                result = options.nullRank;
            } else if (t.isUndefined(x) && t.isDefinedValue(y)) {
                result = options.undefinedRank;
            } else if (t.isNull(y) && t.isDefinedValue(x)) {
                result = -options.nullRank;
            } else if (t.isUndefined(y) && t.isDefinedValue(x)) {
                result = -options.undefinedRank;
            } else {
                result = x < y ? -1 : x > y ? 1 : 0;
                if (currOrder === 'desc') {
                    result = result * -1;
                }
            }
            if (result === 0 && by[byIndex + 1]) {
                result = compareFunc(xIn, yIn, byIndex + 1);
            }
            return result
        }
    }

    return sortArray;

})));